import GeneralConditions from 'containers/Checklist/GeneralConditions';
import { ChecklistLoadable } from '../containers/Checklist/ChecklistLoadable';
import ExternalArea from '../containers/Checklist/ExternalArea';
import House from '../containers/Checklist/House';

import ROUTES, { routesNames } from './constants';

const createChecklistRoutes = () =>
  [
    {
      path: ROUTES.CHECKLIST_EXTERNAL_AREA(),
      name: routesNames.checklist,
      component: ExternalArea,
      exact: true,
    },
    {
      path: ROUTES.CHECKLIST_GENERAL_CONDITIONS(),
      name: routesNames.checklist,
      component: GeneralConditions,
      exact: true,
    },
    {
      path: ROUTES.CHECKLIST_GENERAL_CONDITIONS(),
      name: routesNames.checklist,
      component: GeneralConditions,
      exact: true,
    },
    {
      path: ROUTES.CHECKLIST_HOUSE(),
      name: routesNames.checklist,
      component: House,
      exact: true,
    },
    {
      path: ROUTES.CHECKLIST(),
      name: routesNames.checklist,
      component: ChecklistLoadable,
      exact: true,
    },
  ];

export default createChecklistRoutes;
